import axios, { getVariable } from "./api";
import { keycloak } from "../components/auth";

export const startMatchSigleplayer = (props, themeId, type, categoryId) => {
  window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
  
  createMatchSigleplayer(themeId).then((res) => {
    window.GLOBALS.actualSingleMatch.match_id = res.data.idPartida;
    window.GLOBALS.actualSingleMatch.questions = res.data.listaPerguntas;
    window.GLOBALS.actualSingleMatch.scorePoints = res.data.qtdPontos;
    window.GLOBALS.actualSingleMatch.numeroDeAcertos = 0;
    window.GLOBALS.actualSingleMatch.lastAnswer = {
      indexPergunta: -1,
      resultdoResposta: "",
      dificuldadeResposta: "",
    };

    for (let i = 0; i < window.GLOBALS.actualSingleMatch.questions.length; i++) {
      let questionAnswered = null;
      
      if(res.data.listaPerguntasRespondidas){
        let listQuestionAnswered = res.data.listaPerguntasRespondidas.filter((item) => {
          return item.id === window.GLOBALS.actualSingleMatch.questions[i].id;
        });
        if(listQuestionAnswered && listQuestionAnswered.length > 0){
          questionAnswered = listQuestionAnswered[0]; 
        }
      }

      window.GLOBALS.isInSinglePlayer = true;
      window.GLOBALS.actualSingleMatch.questions[i].respondeu = questionAnswered ? true : false;
      window.GLOBALS.actualSingleMatch.questions[i].acertou = questionAnswered ? questionAnswered.acertou : false;
      window.GLOBALS.actualSingleMatch.questions[i].dificuldade = questionAnswered ? questionAnswered.dificuldade : "M";
    }

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    props.history.push("/tab/" + type + "/" + categoryId + "/" + themeId);
  });
}

export const startMatchMultiplayer = (themeId, userId) => {
  return createMatchMultiplayer(themeId, userId);
};

export const countQuestionsResponded = () => {
  let answared = 0;

  for (let i in window.GLOBALS.actualSingleMatch.questions) {
    let q = window.GLOBALS.actualSingleMatch.questions[i];
    if (q.respondeu) answared++;
  }

  return answared;
};

export const countQuestionsCorrect = () => {
  let answared = 0;

  for (let i in window.GLOBALS.actualSingleMatch.questions) {
    let q = window.GLOBALS.actualSingleMatch.questions[i];
    if (q.acertou) answared++;
  }

  return answared;
};

export const createMatchSigleplayer = async (themeId) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.post(
    (await getVariable("CONHECIGAME_API")) + `/v1/partida/singleplayer/${themeId}`,
    {},
    headers
  );
};

export const createMatchMultiplayer = async (themeId, userId) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.post(
    (await getVariable("CONHECIGAME_API")) + `/v1/partida/multiplayer/${themeId}/${userId}`,
    {},
    headers
  );
};

export const findMatchHistory = async (id) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + `/v1/partida/historico/${id}`,
    headers
  );
};

export const findMatchStatus = async (id) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + `/v1/partida/status/${id}`,
    headers
  );
};

export const finishMatchMultiplayer = async (obj) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.put(
    (await getVariable("CONHECIGAME_API")) + `/v1/partida/finalizar-partida`,
    obj,
    headers
  );
};
